import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DidDismissOnHoldPassesAlert } from '@/types';
import { TransientStorageService } from '@/utils/services';

import { RootState } from '../store';

export interface MyVisitState {
  userDidDismissOnHoldAlert: DidDismissOnHoldPassesAlert;
  salesChannel: string | null;
}

const initialState: MyVisitState = {
  userDidDismissOnHoldAlert: TransientStorageService.getDidDismissOnHoldPassesAlert(),
  salesChannel: null,
};

export const myVisitSlice = createSlice({
  name: 'myVisit',
  initialState,
  reducers: {
    setUserDidDismissOnHoldAlert: (state, action: PayloadAction<DidDismissOnHoldPassesAlert>) => {
      state.userDidDismissOnHoldAlert = action.payload;
    },
    setSalesChannel: (state, action: PayloadAction<undefined | null | string>) => {
      state.salesChannel = action.payload || 'ASWF';
    },
  },
});

export const {
  setUserDidDismissOnHoldAlert: setUserDidDismissOnHoldAlertAction,
  setSalesChannel: setSalesChannelAction,
} = myVisitSlice.actions;

export default myVisitSlice.reducer;

export const getUserDidDismissOnHoldAlert = (state: RootState) =>
  state.myVisit.userDidDismissOnHoldAlert;
